import { AlertTriangle, Star, Check, ChevronRight, Edit } from "lucide-react";
import { getDomainConfig } from "./constants";

// Urgent tasks section
export const UrgentSection = ({ tasks, onComplete, onEdit, showViewAll, onViewAll }) => {
  if (tasks.length === 0) return null;
  
  return (
    <div className="bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl p-4 border border-red-100">
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="w-5 h-5 text-red-500" />
        <h2 className="font-semibold text-red-800">Urgenze</h2>
        <span className="text-xs text-red-600 bg-red-100 px-2 py-0.5 rounded-full">{tasks.length}</span>
      </div>
      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {(showViewAll ? tasks : tasks.slice(0, 3)).map(task => {
          const domainConfig = getDomainConfig(task.domain);
          return (
            <div key={task.task_id} className="bg-white rounded-xl p-3 flex items-center gap-3 shadow-sm">
              <button 
                onClick={() => onComplete(task.task_id)} 
                className="w-5 h-5 rounded border-2 border-red-300 hover:border-green-500 hover:bg-green-50 flex-shrink-0" 
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-800 truncate">{task.title}</p>
                <span className="text-[10px] text-gray-500">{domainConfig.emoji} {task.custom_domain || domainConfig.label}</span>
              </div>
              {onEdit && (
                <button onClick={() => onEdit(task)} className="p-1 text-gray-400 hover:text-gray-600">
                  <Edit className="w-3.5 h-3.5" />
                </button>
              )}
            </div>
          );
        })}
      </div>
      {!showViewAll && tasks.length > 3 && onViewAll && (
        <button onClick={onViewAll} className="text-xs text-red-600 hover:text-red-800 mt-2 flex items-center gap-1">
          Mostra tutti ({tasks.length}) <ChevronRight className="w-3 h-3" />
        </button>
      )}
    </div>
  );
};

// Priority tasks section
export const PrioritySection = ({ tasks, onComplete }) => {
  if (tasks.length === 0) return null;
  
  return (
    <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-2xl p-4 border border-amber-100">
      <div className="flex items-center gap-2 mb-3">
        <Star className="w-5 h-5 text-amber-500 fill-amber-400" />
        <h2 className="font-semibold text-amber-800">Top 3 Priorità</h2>
        <span className="text-xs text-amber-600 bg-amber-100 px-2 py-0.5 rounded-full">{tasks.length}/3</span>
      </div>
      <div className="grid gap-3 sm:grid-cols-3">
        {tasks.map((task, idx) => {
          const domainConfig = getDomainConfig(task.domain);
          return (
            <div key={task.task_id} className="bg-white rounded-xl p-4 shadow-sm">
              <div className="flex items-start gap-3">
                <span className="w-7 h-7 rounded-full bg-gradient-to-br from-amber-400 to-amber-500 text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
                  {idx + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-800">{task.title}</p>
                  <span className="text-[10px] text-gray-500">{domainConfig.emoji} {task.custom_domain || domainConfig.label}</span>
                </div>
                <button 
                  onClick={() => onComplete(task.task_id)} 
                  className="p-1.5 text-gray-400 hover:text-green-600 hover:bg-green-50 rounded-lg"
                >
                  <Check className="w-4 h-4" />
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
